<template>
    <div class="root">
        <div class="content">
            <NavigationBar />
            <div class="container" style="margin-top: 20px;">
                <div class="row align-items-start">
                    <div class="col-12 col-md-6">
                        <div class="card" style="border-bottom-left-radius: 20px; border-bottom-right-radius: 20px; margin-top: 40px;">
                            <div class="col">

                                <div class="image-wrapper d-flex justify-content-center">
                                    <p class="cart-total">${{ getSelectedProduct.price }}</p>
                                    <img :src="getSelectedProduct.image" style="width: 200px; height: 200px; margin-top: 20px;">
                                </div>
                                <br>
                                <div class="card-body product-body">
                                    <h4 class="card-title">{{ getSelectedProduct.title }}</h4>
                                    <button class="cart-button btn btn-light" @click=addToCart>Add to Cart</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="product-card">
                            <h4 class="product-header">Product Description</h4>
                            <p style="margin:10px">{{ getSelectedProduct.description }}</p>
                            <span class="related_items_container">
                                <h5 class="product-header">You may also like:</h5>
                            </span>
                            <div>
                                <span class="row" v-if="getAllProductData && !getIsProductDataLoading">
                                    <span class="related_items col-12 col-md-4" v-for="item in getAllProductData"
                                        :key=item.id>
                                        <img :src="item.image">
                                        <h5>{{ item.title }}</h5>
                                    </span>
                                </span>
                                <span class="spinner-grow" role="status" v-else> </span>
                            </div>
                        </div>
                        <p>{{ this.$store.cart }}</p>
                    </div>
                </div>
            </div>
        </div>
        <FooterView />
    </div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'
import FooterView from '../components/Footer.vue'
export default {
    name: "ProductScreen",
    components: {
        NavigationBar,
        FooterView
    },
    computed: {
        cartTotal() {
            return this.$store.totalItemsInCart
        },
        getSelectedProduct() {
            return this.$store.state.selectedItem
        },
        getAllProductData() {
            let holderArray = Array
            if (this.$store.state.allProducts) {
                holderArray = this.$store.state.allProducts
                if (Array.isArray(holderArray)) {
                    holderArray = holderArray.filter(data => data.category.includes(this.getSelectedProduct.category) && data.id != this.getSelectedProduct.id).splice(0, 3)
                    console.log("holderArray: " + JSON.stringify(holderArray))
                }
                return holderArray
                //.filter(data => data.category.includes(this.getSelectedProduct.category) && data.id != this.getSelectedProduct.id).splice(0,3);
            }
            else {
                return null
            }
        },
        getIsProductDataLoading() {
            return this.$store.state.isAllProductsLoading
        }
    },
    methods: {
        addToCart() {
            this.$store.commit('increment')
            this.$store.commit('addToCart', this.$store.state.selectedItem)
            console.log("Cart currently: " + JSON.stringify(this.$store.state.cart))
        }
    },
    async mounted() {
        this.$store.dispatch('getAllProducts')
    }

}
</script>

<style scoped>
.related_items_container {
    display: flex;
    width: 100%;
}

.related_items {
    margin-left: 10px;
    width: 160px;
    height: 160px;
}

.related_items img {
    width: 80px;
    height: 80px;
}

.related_items h5 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.root {
    display: flex;
    flex-direction: column;
    height: 100%;
    /* or 100vh if it's the viewport */
}

.content {
    flex: 1;
    /* takes all available space */
}

.cart-total {
    position: absolute;
    width: 80px;
    height: 80px;
    right: 140px;
    background-color: orange;
    color: white;
    border: solid yellow 2px;
    border-radius: 50%;
    text-align: center;

    display: flex;
    align-items: center;
    justify-content: center;
}

.image-wrapper {
    position: relative;
    display: inline-block;
    /* or block, depending on layout */
    width: 100%;
    /* optional, for responsiveness */
}

.image-wrapper img {
    width: 100%;
    /* responsive image */
    height: auto;
    display: block;
}

.product-card {

    border-style: solid;
    border-color: orange;
    border-width: 3px;
    border-radius: 12px;

    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
    margin-right: 20px;
}
.product-body{
  background-color: orange !important;
  color: white !important;
  overflow: hidden !important;
  border-bottom-right-radius: 20px !important;
  border-bottom-left-radius: 20px !important;

}
.product-header {
    background-color: orange;
    color: white;
    width: 100%;
    margin: 0;
    /* Remove default margin */
    margin-bottom: 10px;

    width: 100%;
}

.cart-button {
    margin: 20px;
}
</style>